var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar2Fill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 1.66666H7.5V3.33332H12.5V1.66666H14.1667V3.33332H16.6667C17.1269 3.33332 17.5 3.70642 17.5 4.16666V5.83332H2.5V4.16666C2.5 3.70642 2.8731 3.33332 3.33333 3.33332H5.83333V1.66666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 7.08334H2.5V17.5C2.5 17.9603 2.8731 18.3333 3.33333 18.3333H16.6667C17.1269 18.3333 17.5 17.9603 17.5 17.5V7.08334ZM7.5 10.4167H5.83333V12.0833H7.5V10.4167ZM9.16667 10.4167H10.8333V12.0833H9.16667V10.4167ZM14.1667 10.4167H12.5V12.0833H14.1667V10.4167ZM5.83333 13.3333H7.5V15H5.83333V13.3333ZM10.8333 13.3333H9.16667V15H10.8333V13.3333ZM12.5 13.3333H14.1667V15H12.5V13.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2Fill);
export default __webpack_public_path__ + "static/media/calendar_2_fill.d2539dc0cc2bf7520273346e0b8b3e5e.svg";
export { ForwardRef as ReactComponent };